import React from 'react';
import { Space, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

export interface ResponseFormatRow {
  id?: string;
  formatId: string;  // 业务标识
  formatType: string;
  description?: string;
  maxLength?: number;
  isActive?: boolean;
  [k: string]: any;
}

export const getColumns = (
  onEdit: (record: ResponseFormatRow) => void,
  onDelete: (id: string) => void
) => [
  { title: '格式ID', dataIndex: 'formatId', key: 'formatId', width: 200 },
  { title: '格式类型', dataIndex: 'formatType', key: 'formatType', width: 150 },
  { title: '描述', dataIndex: 'description', key: 'description', width: 200, ellipsis: true },
  { title: '最大长度', dataIndex: 'maxLength', key: 'maxLength', width: 100 },
  {
    title: '是否启用',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 100,
    render: (val: boolean) => (val ? '是' : '否'),
  },
  {
    title: '操作',
    key: 'action',
    width: 150,
    fixed: 'right' as const,
    render: (_: any, record: ResponseFormatRow) => (
      <Space>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined />}
          onClick={() => onEdit(record)}
          title="编辑"
        />
        <Popconfirm
          title="确定要删除该返回格式吗？"
          onConfirm={() => onDelete(record.id!)}
        >
          <Button type="link" danger size="small" icon={<DeleteOutlined />} title="删除" />
        </Popconfirm>
      </Space>
    ),
  },
];

export const tableConfig = {
  rowKey: (r: ResponseFormatRow) => r.id || r.formatId,
  pagination: {
    pageSize: 20,
    showSizeChanger: true,
    showTotal: (total: number) => `共 ${total} 条`,
  },
};
